<div class="mp-section-header-text font-t fm-mt-30px fm-mb-20px" *ngIf="groupInfo.length > 0"
    >Group Memberships</div
>
<div *ngIf="groupInfo.length > 0">
    <div *ngFor="let group of groupInfo; let i = index">
        <div class="mp-group-row w-full">
            <app-group-logo [logoUrl]="group.groupLogo" [logoClass]="'logo-profile-view'">
            </app-group-logo>
            <div class="group-info">
                <div class="group-name">{{ group.groupName }}</div>
                <div *ngIf="group.groupMember" class="group-since"
                    >Member since
                    {{ utilsService.getMemberSinceFormat(group.groupMemberSince, timeZone) }}</div
                >
                <div *ngIf="!group.groupMember" style="font-style: italic" class="group-since"
                    >Invited</div
                >
            </div>
        </div>
        <div *ngIf="i < groupInfo.length - 1" class="customHrGroups">.</div>
    </div>
</div>
